import { AdBiddingProvider, IAdBiddingProviderConfig } from '../../..'
import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { AdBiddingBase } from '../base'

class DistrictM extends AdBiddingBase {
    public requestAds: undefined
    public requestAdsPromise: undefined
    protected URLPath: string
    protected waitForBidder = false
    protected bidderType = 'districtm'

    constructor() {
        super()
        this.URLPath = '//hb.districtm.io/prod/100549/all.postmedia.js'
    }

    public initializeBidding(confs: IAdBiddingProviderConfig[]): void {
        const conf = confs.find((_) => _.client === AdBiddingProvider.DISTRICT_M)
        if (conf) {
            DOMUtils.loadScript(this.URLPath)
            logger(`debug`, `Initialize DistrictM bidder: ${this.URLPath}`)
        }
    }
}

export default DistrictM
